module.exports = __webpack_public_path__ + "img/hero.0a0d2f41.png";